<template>
  <div
    v-if="item"
    :class="{
      'flex-end mobile-none tablet-none': mode === 'DESKTOP',
      'flex-between width-percent-100 margin-bottom-16 desktop-none':
        mode === 'MOBILE',
    }"
  >
    <span
      v-if="item.statusId && !item.isAbsent"
      :class="`chips background-${generateStatusColor()}`"
    >
      {{ item.statusCaption }}
    </span>
    <span v-if="item.isAbsent" :class="`chips background-error-50 color-error`">
      {{ $lang.notPresentInExercise }}
    </span>
    <span v-if="!item.isAbsent" class="flex-end">
      <ErrorCount
        class="margin-right-12"
        :visible="!!item.evidenceErrorCount"
        :count="item.evidenceErrorCount"
      />
      <router-link
        :to="goToCompetencyLink"
        class="color-complementary-200 icon-hover margin-right-8"
        v-b-tooltip.hover
        :title="$lang.gradingCompetency"
      >
        <mdicon name="folder-eye-outline" size="24" />
      </router-link>
      <MenuPopupWrapper
        iconClass="color-complementary-200 icon-hover"
        menuClass="left-0 top-10 z-index-1 padding-top-24"
        :items="menuPopupItems"
        :permissions="permissions"
        :showMenu="isMenuPopup"
        :rowItem="item"
        :hasEventCapturing="false"
        @click="handleOpenMenuPopup"
        @close="handleCloseMenuPopup"
      />
    </span>
  </div>
</template>

<script>
import { ErrorCount, MenuPopupWrapper } from "@/components/re-design";
import { pathOr } from "ramda";
import { ref, toRefs } from "vue";
export default {
  components: { MenuPopupWrapper, ErrorCount },
  props: {
    mode: {
      type: String,
      default: "DESKTOP",
    },
    item: {
      type: Object,
      default: null,
    },
    menuPopupItems: {
      type: Array,
      default: () => [],
    },
    permissions: {
      type: Array,
      default: () => [],
    },
    goToCompetencyLink: {
      type: String,
      default: "",
    },
  },
  setup(props) {
    // bind props
    const { item } = toRefs(props);

    const generateStatusColor = () => {
      const { statusId } = item.value;
      const colors = {
        1: "warning-50 color-warning",
        2: "primary-50 color-primary",
        3: "success-50 color-success",
        4: "success color-surface",
        5: "complementary-50 color-complementary-200",
        6: "complementary-50 color-complementary-200",
        7: "warning color-surface",
        8: "primary color-surface",
      };
      return pathOr("", [statusId], colors);
    };

    // handle menu popup
    const isMenuPopup = ref(false);
    const handleOpenMenuPopup = () => (isMenuPopup.value = !isMenuPopup.value);
    const handleCloseMenuPopup = () => (isMenuPopup.value = false);

    // return data to be used in template
    return {
      item,
      generateStatusColor,
      isMenuPopup,
      handleOpenMenuPopup,
      handleCloseMenuPopup,
    };
  },
};
</script>
